import { Card, Elevation, Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';
import { Text, Tooltip } from 'vet-bones/components';
import { alphaSort } from 'vet-bones/utils';

import { getOverviewDrawerViewItemTestId } from 'src/constants/testIds';
import {
  projectInvalidRulesByIdSelector,
  projectRulesByIdSelector,
} from 'src/selectors/projectRules';
import { uiSlice } from 'src/store/ui/ui.slice';
import * as copy from 'src/templates/copy';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const ProjectRuleOverviewDrawerView: React.VFC = () => {
  const dispatch = useReduxDispatch();

  const { projectId } = useRouterParams();

  const invalidRulesById = useReduxSelector(
    projectInvalidRulesByIdSelector(projectId)
  );
  const rulesById = useReduxSelector(projectRulesByIdSelector(projectId));

  const handleEdit = React.useCallback(
    (ruleId: string) => {
      dispatch(
        uiSlice.actions.toggledRuleDetailDrawer({ isOpen: true, ruleId })
      );
    },
    [dispatch]
  );

  const list = Object.values(rulesById)
    .sort(alphaSort(({ name }) => name))
    .sort((a, b) => {
      if (invalidRulesById[a.id] && !invalidRulesById[b.id]) {
        return -1;
      }

      if (!invalidRulesById[a.id] && invalidRulesById[b.id]) {
        return 1;
      }

      return 0;
    })
    .map(({ id, name }, idx) => (
      <Card
        key={id}
        className="sd-drawer-project-rule-overview__view__card"
        data-testid={getOverviewDrawerViewItemTestId(id, idx)}
        elevation={Elevation.ONE}
        interactive
        onClick={() => {
          handleEdit(id);
        }}
      >
        <Text ellipsize>{name}</Text>
        {invalidRulesById[id] ? (
          <Tooltip
            content={copy.components.projectRuleOverviewDrawer.invalidRule}
          >
            <Icon icon={IconNames.WARNING_SIGN} />
          </Tooltip>
        ) : null}
      </Card>
    ));

  return <div className="sd-drawer-project-rule-overview__view">{list}</div>;
};
